import React from "react";

import { useEntityDetail } from "./entity-detail-provider";
import { IssueTypeDetailDialog } from "./issue-type-detail-dialog";
import { StageDetailDialog } from "./stage-detail-dialog";
import { WorkflowDetailDialog } from "./workflow-detail-dialog";

// Singleton dialog host — mounted ONCE in the workspace layout route, below
// the provider that owns the state (split-context rule), never per chip.
// `issue` never reaches here (the provider delegates it to the issue-view
// overlay), `team` never does either (the provider navigates to the team
// page), and `user` presents in the right-side profile island
// (MemberProfilePanelHost, mounted as AppShell's rightPanel) instead of a
// centered dialog.
export function EntityDetailDialogs() {
  const { active, closeEntity } = useEntityDetail();

  const onOpenChange = (open: boolean) => {
    if (!open) closeEntity();
  };

  switch (active?.kind) {
    case "stage":
      return <StageDetailDialog stageId={active.id} open onOpenChange={onOpenChange} />;
    case "workflow":
      return (
        <WorkflowDetailDialog workflowId={active.id} open onOpenChange={onOpenChange} />
      );
    case "issueType":
      return (
        <IssueTypeDetailDialog
          issueTypeId={active.id}
          open
          onOpenChange={onOpenChange}
        />
      );
    default:
      return null;
  }
}
